import { useContext, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';
import AuthContext from 'contexte/AuthContext';
import Modal from 'components/modal/Modal';
import PageLoader from 'components/pageLoader/PageLoader';
import { launchError, launchSuccess } from 'components/notifications';
import { closeStructuredProduct, fetchSpClosingPreview } from 'services/structuredProductsServices';
import { couponsErrorLabel } from './couponsErrors';
import CouponsTable from './CouponsTable';
import './closeProductModal.css';

const CLOSING_ERRORS = {
  already_closed: 'Produit déjà clôturé',
  nothing_invested: 'Aucun montant investi sur ce produit',
}

const CloseProductModal = ({ productId, isOpen, onClose, onClosed }) => {

  const { t } = useTranslation();
  const { user } = useContext(AuthContext);
  const [preview, setPreview] = useState(null);
  const [loading, setLoading] = useState(false);
  const [closing, setClosing] = useState(false);

  useEffect(() => {
    if (!isOpen) return;
    setPreview(null);
    setLoading(true);
    fetchSpClosingPreview({ user, productId })
      .then(setPreview)
      .catch(error => {
        launchError(CLOSING_ERRORS[error?.response?.data?.error] || t('notifications.structured_products.close.error'));
        onClose();
      })
      .finally(() => setLoading(false));
  }, [isOpen])

  const confirmClose = async () => {
    try {
      setClosing(true);
      const result = await closeStructuredProduct({ user, productId });
      launchSuccess(t('notifications.structured_products.close.success'));
      if (result.coupons_created) launchSuccess(`${result.coupons_created} coupons créés`);
      onClosed?.(result);
      onClose();
    } catch (error) {
      launchError(CLOSING_ERRORS[error?.response?.data?.error] || t('notifications.structured_products.close.error'));
    } finally {
      setClosing(false);
    }
  }

  return (
    <Modal isOpen={isOpen} onClose={onClose} width={'700px'}>
      <h2>Clôturer le produit</h2>
      {loading || !preview ? (
        <div className='pageLoaderBox'><PageLoader /></div>
      ) : (
        <div className='close_sp_modal'>
          <p>Montant investi : <b>{preview.invested} €</b></p>
          <p>Nouveau total : <b>{preview.total} €</b></p>
          <p>Le status passera à <b>closed</b> et le pourcentage de chaque investissement sera recalculé sur ce total.</p>
          {preview.term_sheet_url && <p><a href={preview.term_sheet_url} target="_blank" rel="noreferrer">Term sheet</a></p>}
          {preview.coupons?.length > 0 ? (
            <>
              <p>{preview.coupons.length} coupons seront créés :</p>
              <CouponsTable coupons={preview.coupons} />
            </>
          ) : (
            <p className='close_sp_modal_warning'>{couponsErrorLabel(preview.coupons_error)}</p>
          )}
          <div className='close_sp_modal_actions'>
            <button className='structured_product_copy_button' onClick={onClose}>Annuler</button>
            <button className='structured_product_refund_button' disabled={closing} onClick={confirmClose}>
              {closing ? 'Clôture...' : 'Confirmer la clôture'}
            </button>
          </div>
        </div>
      )}
    </Modal>
  )
}

export default CloseProductModal
